module.exports = __webpack_public_path__ + "img/missingWord.a755ab6f.png";